var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0C8.53875 0 6.21 2.27636 5.88441 5.18182C5.25812 5.28393 4.67077 5.55549 4.18453 5.96773C3.69828 6.37998 3.33124 6.91758 3.12225 7.52364C1.35412 8.03927 0 9.63491 0 11.6364C0 14.0538 1.92338 16 4.3125 16H18.6875C21.0766 16 23 14.0538 23 11.6364C23 10.3564 22.3855 9.21018 21.4949 8.40873C21.3282 5.85309 19.3135 3.81382 16.7785 3.68145C15.9131 1.55127 13.9279 0 11.5 0ZM11.5 1.45455C13.4852 1.45455 15.0722 2.74182 15.6328 4.56727L15.7909 5.09091H16.5312C18.5114 5.09091 20.125 6.72364 20.125 8.72727V9.09091L20.4168 9.31855C20.769 9.59167 21.0552 9.94228 21.2537 10.3438C21.4522 10.7454 21.5578 11.1874 21.5625 11.6364C21.5625 13.2916 20.3234 14.5455 18.6875 14.5455H4.3125C2.67662 14.5455 1.4375 13.2916 1.4375 11.6364C1.4375 10.1673 2.47969 9.02691 3.795 8.79564L4.26722 8.70473L4.35706 8.22618C4.57269 7.24655 5.43087 6.54545 6.46875 6.54545H7.1875V5.81818C7.1875 3.36727 9.07781 1.45455 11.5 1.45455ZM11.5 5.52291L10.9825 6.02255L8.1075 8.93164L9.1425 9.97891L10.7812 8.31782V13.0909H12.2188V8.31782L13.8575 9.97745L14.8925 8.93018L12.0175 6.02109L11.5 5.52291Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.74473c9106b7549fa25ec71bbd172d8e.svg";
export { ForwardRef as ReactComponent };